import moment from "moment";
import { useState } from "react";

export const useReservationState = () => {
  const [primaryKey, setPrimaryKey] = useState<number>(0);
  const [reservation, setReservation] = useState<any>(null);
  const [reservationDataFromCofirm, setReservationDataFromCofirm] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [isNavigate, setIsNavigate] = useState<boolean>(false);

  return {
    primaryKey, setPrimaryKey,
    reservation, setReservation,
    reservationDataFromCofirm, setReservationDataFromCofirm,
    currentPage, setCurrentPage,
    isNavigate, setIsNavigate
  };
};

export const useCustomerState = () => {
  const [customerId, setCustomerId] = useState<number>(0);
  const [customerData, setCustomerData] = useState<any | null>(null);
  const [localAddress, setLocalAddress] = useState<string>("");
  const [confirmSignatureURL, setConfirmSignatureURL] = useState<any | null>();
  const [existingEmail, setExistingEmail] = useState<string>("");
  const [existingBirthday, setExistingBirthday] = useState<string>("");

  return {
    customerId, setCustomerId,
    customerData, setCustomerData,
    localAddress, setLocalAddress,
    confirmSignatureURL, setConfirmSignatureURL,
    existingEmail, setExistingEmail,
    existingBirthday, setExistingBirthday
  };
};

export const useLocationState = () => {
  const [branches, setBranches] = useState<any[]>([]);
  const [branchId, setBranchId] = useState<string>("");
  const [locations, setLocations] = useState<any[]>([]);
  const [locationDataIsLoaded, setLocationDataIsLoaded] = useState<boolean>(false);
  const [pickupLocationId, setPickupLocationId] = useState<string>("0");
  const [returnLocationId, setReturnLocationId] = useState<string>("0");
  const [pickupLocationOptionsOfParticularBranch, setPickupLocationOptionsOfParticularBranch] = useState<any[]>([]);
  const [returnLocationOptionsOfParticularBranch, setReturnLocationOptionsOfParticularBranch] = useState<any[]>([]);
  const [locationOpenHourOfParticularBranch, setLocationOpenHourOfParticularBranch] = useState<any[]>([]);
  const [locationFeeAmount, setLocationFeeAmount] = useState<number>(0);
  const [returnToDifferent, setReturnToDifferent] = useState<boolean>(false);

  return {
    branches, setBranches,
    branchId, setBranchId,
    locations, setLocations,
    locationDataIsLoaded, setLocationDataIsLoaded,
    pickupLocationId, setPickupLocationId,
    returnLocationId, setReturnLocationId,
    pickupLocationOptionsOfParticularBranch, setPickupLocationOptionsOfParticularBranch,
    returnLocationOptionsOfParticularBranch, setReturnLocationOptionsOfParticularBranch,
    locationOpenHourOfParticularBranch, setLocationOpenHourOfParticularBranch,
    locationFeeAmount, setLocationFeeAmount,
    returnToDifferent, setReturnToDifferent
  };
};

export const useDateState = () => {
  const currentDate = new Date().toISOString();
  const [pickupDate, setPickupDate] = useState<string>(moment(currentDate).format("YYYY-MM-DD"));
  const [pickupTime, setPickupTime] = useState<string>(moment(new Date().toLocaleString("en-US", {
    timeZone: moment.tz.guess()
  })).format('HH:mm'));
  const [returnDate, setReturnDate] = useState<string>(moment(currentDate).add(1, 'day').format("YYYY-MM-DD"));
  const [returnTime, setReturnTime] = useState<string>(moment(new Date().toLocaleString("en-US", {
    timeZone: moment.tz.guess()
  })).format('HH:mm'));
  const [formattedCreatedAt, setFormattedCreatedAt] = useState<string>("");

  return {
    pickupDate, setPickupDate,
    pickupTime, setPickupTime,
    returnDate, setReturnDate,
    returnTime, setReturnTime,
    formattedCreatedAt, setFormattedCreatedAt,
  };
};

export const useTimezoneState = () => {
  const [timezoneOptions, setTimezoneOptions] = useState<any[]>([]);
  const [timezoneOptionsIsLoaded, setTimezoneOptionsIsLoaded] = useState<boolean>(false);
  const [isBranchSetForFirstTime, setIsBranchSetForFirstTime] = useState<boolean>(false);

  return {
    timezoneOptions, setTimezoneOptions,
    timezoneOptionsIsLoaded, setTimezoneOptionsIsLoaded,
    isBranchSetForFirstTime, setIsBranchSetForFirstTime,
  };
};

export const useVehicleState = () => {
  const [selectedVehicleClass, setSelectedVehicleClass] = useState<any>(null);
  const [availableVehicle, setAvailableVehicle] = useState<any[]>([]);
  const [vehicleClassId, setVehicleClassId] = useState<string>("");

  return {
    selectedVehicleClass, setSelectedVehicleClass,
    availableVehicle, setAvailableVehicle,
    vehicleClassId, setVehicleClassId,
  };
};


export const useRateState = () => {
  const [totalHours, setTotalHours] = useState<number>(0);
  const [hourlyRate, setHourlyRate] = useState<number>(0.0);
  const [totalDays, setTotalDays] = useState<number>(0);
  const [dailyRate, setDailyRate] = useState<number>(0.0);
  const [totalWeeks, setTotalWeeks] = useState<number>(0);
  const [weeklyRate, setWeeklyRate] = useState<number>(0.0);
  const [totalMonths, setTotalMonths] = useState<number>(0);
  const [monthilyRate, setMonthilyRate] = useState<number>(0.0);

  return {
    totalHours, setTotalHours,
    hourlyRate, setHourlyRate,
    totalDays, setTotalDays,
    dailyRate, setDailyRate,
    totalWeeks, setTotalWeeks,
    weeklyRate, setWeeklyRate,
    totalMonths, setTotalMonths,
    monthilyRate, setMonthilyRate
  };
};


export const usePricingState = () => {
  const [extraValue, setExtraValue] = useState<any[]>([]);
  const [checkExtraValue, setCheckExtraValue] = useState<any[]>([]);
  const [taxAmount, setTaxAmount] = useState<number>(0);
  const [mandatoryAdditionalChargesAmount, setMandatoryAdditionalChargesAmount] = useState<number>(0);
  const [governmentTaxAmount, setGovernmentTaxAmount] = useState<number>(0);
  const [extraValueLoaded, setExtraValueLoaded] = useState<boolean>(false);

  return {
    extraValue, setExtraValue,
    checkExtraValue, setCheckExtraValue,
    taxAmount, setTaxAmount,
    mandatoryAdditionalChargesAmount, setMandatoryAdditionalChargesAmount,
    governmentTaxAmount, setGovernmentTaxAmount,
    extraValueLoaded, setExtraValueLoaded,
  };
};
